import script from "./RecommendationsEdition.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendationsEdition.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendationsEdition.vue?vue&type=style&index=0&id=6aa355da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa355da"]])

export default __exports__